export default __webpack_public_path__ + "static/162-38b8d147e1d27eae79fa6d520927e002.gif";